type StaticImageKey =
  | 'done'
  | 'view-all'
  | 'education'
  | 'check'
  | 'filter-cta'
  | 'globe'
  | 'info'
  | 'right-arrow'
  | 'star45'
  | 'star5'
  | 'arrow'
  | 'sign-in-arrow'
  | 'default-user'
  | 'recommended'
  | 'apple-touch-icon'
  | 'customer-home-texture'
  | 'search'
  | 'close';

export type StaticImages = Record<StaticImageKey, string>;

export default defineNuxtPlugin({
  name: 'static-images',
  async setup() {
    const staticImages: StaticImages = {
      done: '',
      'view-all': '',
      education: '',
      check: '',
      'filter-cta': '',
      globe: '',
      info: '',
      'right-arrow': '',
      star45: '',
      star5: '',
      arrow: '',
      'sign-in-arrow': '',
      'default-user': '',
      recommended: '',
      'apple-touch-icon': '',
      'customer-home-texture': '',
      search: '',
      close: '',
    };

    const loadImage = async (key: StaticImageKey) => {
      // Call your existing composable that fetches a static image
      const result = await useStaticImage(key);
      if (result) staticImages[key] = result.cdnPathname;
    };

    await Promise.all((Object.keys(staticImages) as StaticImageKey[]).map((key) => loadImage(key)));

    return {
      provide: {
        staticImages,
      },
    };
  },
});
